module.exports = __webpack_public_path__ + "media/images/pc/specials/okinawa_churaumi_aquarium/bg_bubble_02-698ae4008a94db190dcdb48350520a4a.png";